import React from 'react';
import { themr } from 'react-css-themr';
import classnames from 'classnames';
import theme from './Loader.scss';

const PlaceholderLoader = Wrapped => {
    class PlaceholderLoaderComponent extends React.Component {
        render() {
            const {
                loading,
                placeholderLoaderClassName,
                theme,
                ...others
            } = this.props;
            if (loading) {
                return (
                    <div
                        data-toolbox="placeholder-loader"
                        className={classnames(theme.placeholderLoader, {
                            [placeholderLoaderClassName]: placeholderLoaderClassName
                        })}
                    >
                        <Wrapped {...others} loading={loading} theme={theme} />
                        &nbsp;
                    </div>
                );
            } else {
                return <Wrapped {...others} loading={loading} theme={theme} />;
            }
        }
    }
    return themr('PlaceholderLoader', theme)(PlaceholderLoaderComponent);
};

export default PlaceholderLoader;
